export default "__VITE_ASSET__Cm4zczE4__"